import { createFileRoute } from '@tanstack/react-router';

import { BulkUploadImportResultsPage } from '~pages/parents/bulk-upload/results';

export const Route = createFileRoute(
  '/_auth/_layout/parents/bulk-upload/results/$jobId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { jobId } = Route.useParams();
  return <BulkUploadImportResultsPage jobId={jobId} />;
}
